class DlPageBigSwipeX extends HTMLElement {
    constructor() {
      super();
      this.swiperEl = this.querySelector('.swiper');
      this.initSwiper();
      this.addResizeListener();
    }
    
    // 计算spaceBetween的方法
    calculateSpaceBetween() {
      if (window.innerWidth <= 990) {
        return (8 / 375) * window.innerWidth;
      } else if (window.innerWidth <= 1600) {
        return (24 / 1600) * window.innerWidth;
      } else if (window.innerWidth >= 1920) {
        return (24 / 1920) * window.innerWidth;
      } else {
        // 1600-1920px之间的值 
        return 24;
      }
    }
    
    initSwiper() {
      // 确保Swiper已加载
      if (typeof Swiper === 'undefined') {
        console.warn('Swiper not loaded, retrying in 100ms');
        setTimeout(() => this.initSwiper(), 100);
        return;
      }
    
      // 检测是否为移动端
      const isMobile = window.innerWidth <= 990;
      
      // 使用全局 Swiper 实例
      this.swiper = new Swiper(this.swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: this.calculateSpaceBetween(),
        loop: false,
        // 确保滑动行为正确
        resistance: true,
        resistanceRatio: 0.85,
        navigation: {
          nextEl: this.querySelector('.dl-page-big-swipe-X-swiper-button-next'),
          prevEl: this.querySelector('.dl-page-big-swipe-X-swiper-button-prev'),
        },
      });
      
    }
    
    addResizeListener() {
      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          this.handleResize();
        }, 250);
      });
    }
    
    handleResize() {
      if (!this.swiper) return;
      
      // 更新swiper的spaceBetween
      this.swiper.params.spaceBetween = this.calculateSpaceBetween();
      this.swiper.update();
    }
    
    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
      }
    }
  }
  
  // 确保只定义一次
  if (!customElements.get('dl-page-big-swipe-x')) {
    customElements.define('dl-page-big-swipe-x', DlPageBigSwipeX);
  }